import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "p-card p-shadow-2 p-text-bold p-p-3 p-text-center p-text-uppercase" }, " Tableau de board ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"1.2em","line-height":"1.5em"} }, " Cette section vous permet de voir des tableaux et des graphes statistiques. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-my-3 p-card" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/dashboard.PNG" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Vous aurez l'occasion de voir le résumé de votre "),
  /*#__PURE__*/_createElementVNode("mark", null, "activité"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_5 = { class: "p-d-flex p-justify-center p-pt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        style: {"width":"50%"},
        label: "Passer à la section précedente",
        class: "p-button-warning p-shadow-4 p-py-3 p-button-rounded",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/documentation/rapport')))
      })
    ])
  ], 64))
}